import React, { useEffect, useMemo, useState } from "react";
import useStableCallbacks from "../../../customHooks/useStableCallbacks";
import useProgressiveList from "../../../customHooks/useProgressiveList";
import {
  Box,
  Button,
  Checkbox,
  Drawer,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import {
  AccountLevelArkchatPermission,
  GroupLevelArkchatPermission,
  InviteType,
} from "../../../utils/constant";
import {
  createStyledIndicatorButton,
  StyledSideBarInviteButton,
} from "../../../common/StyledComponents/SideBarComponents";
import { groupExternalMember } from "../../../utils/externalMemberGroping";
import { useTranslation } from "react-i18next";
import { colorSchemes, fontSizeSchemes, crossIcon, crossIconDiv, personIconStyle } from "../../../assets/commonFunction";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import NewOrganisationProfile from "../../Profille/NewOrganisationProfile";
import SwitchAccount from "../../Switch/SwitchAccount";
import PersonIcon from "../../../assets/images/chats/person.svg";

const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#000000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,

  internalExternalButton: {
    background: "white",
    border: "1px solid #183243",
    color: "#183243",
    borderRadius: "0px",
    fontSize: "0.75rem",
    textTransform: "none",
    "&:hover": {
      background: "white",
    },
  },

  activeButton: {
    "&:hover": {
      background: "#183243",
    },
    background: "#183243",
    borderRadius: "0px",
    color: "white",
    fontSize: "0.75rem",
    textTransform: "none",
    border: "1px solid #183243",
  },

  radiogp: {
    display: "block",
  },
  groupMember: {
    backgroundColor: "#fff",
    padding: "10px 20px",
  },
};

// One account member in the list. Memoized: ticking one re-renders only
// that row (each tick re-rendered every member of the account).
const InternalMemberRow = React.memo(function InternalMemberRow({
  item,
  selected,
  viewerIsAccountOwner,
  onSelect,
}) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      padding="0rem 1.18rem 0rem 1.2rem"
    >
      <FormControlLabel
        sx={classes.checked}
        control={
          <Checkbox
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 30,
                color: "#183243",
              },
            }}
            checked={selected}
            onChange={(event) =>
              onSelect(event, item)
            }
            icon={
              <Box
                sx={{
                  width: "2rem",
                  height: "2rem",
                  backgroundColor: colorSchemes.personIconBg,
                  borderRadius: "0.2rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={PersonIcon}
                  alt="user"
                  style={{ display: "block", ...personIconStyle }}
                />
              </Box>
            }
          />
        }
        label={item?.userInfo?.firstName}
        name={String(item?.userId)}
      />
      {/* {
    {item?.activePermission ===
      AccountLevelArkchatPermission?.ADMIN &&
      item?.inviteType === 0} */}
      {/* <FormControlLabel
        control={
          <Switchs
            switchLabel={appContent?.manager}
            checked={memberPermission?.includes(item?.userId)}
            handleChange={(event) =>
              handleChangePermission(event, item)
            }
          />
        }
      /> */}
      <>
        {item?.inviteType === InviteType?.ownerInviteType &&
          (item?.permission ===
            AccountLevelArkchatPermission?.ADMIN ||
            viewerIsAccountOwner) && (
            <Box>
              <Typography>Owner</Typography>
            </Box>
          )}
        {item?.inviteType === InviteType?.internal &&
          item?.permission ===
            AccountLevelArkchatPermission?.ADMIN && (
            <Box>
              <Typography>Admin</Typography>
            </Box>
          )}
        {item?.permission ===
          AccountLevelArkchatPermission?.USER && (
          // don't remove it, this can be enabled in future
          // <FormControlLabel
          //   control={
          //     <Switchs
          //       switchLabel="Manager"
          //       checked={groupMemeberPermission?.includes(
          //         item?.userId
          //       )}
          //       handleChange={(event) =>
          //         handleChangeInternalMemberGrpPermission(
          //           event,
          //           item
          //         )
          //       }
          //     />
          //   }
          // />
          <Box>
            <Typography>User</Typography>
          </Box>
        )}
      </>
    </Stack>
  );
});

const CreateGroup = ({
  handleClosegroupdrawer,
  handlesavearkchatgroup,
  handleNameChange,
  handleDescriptionChange,
  newGroupName,
  newGroupDescription,
  isRequired,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const NameBadge = createStyledIndicatorButton("#E3E1E1");
  const [firsttimesnackvisible, setfirsttimesnackvisible] = useState(true);
  const [externalGroupMember, setExternalGroupMemebr] = useState({});
  const [externalMemberData, setExternalMemberData] = useState([]);
  const [activeButton, setActiveButton] = useState("internal");
  const [isSwitchAccountDrawerOpen, setSwitchAccountDrawerOpen] =
    useState(false);
  const [isCreateNewOrgAccountDrawerOpen, setCreateNewOrgAccountDrawerOpen] =
    useState(false);
  const accountLevelPeople = useSelector(
    (state) => state?.arkchatgroup?.accountLevelPeople
  );

  const userData = useSelector((state) => state?.profile);
  const [selectedGroupMember, setSelectedGroupMember] = useState({
    selectedInternalGroupMember: [],
    selectedExternalGroupMember: [],
  });
  const [selectedInternalMember, setSelectedInternalMember] = useState([]);
  const [memberPermission, setMemberPermission] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (accountLevelPeople?.externalMember?.length > 0) {
      const groupedExternalData = groupExternalMember(
        accountLevelPeople?.externalMember,
        false,
        appContent?.KEY34
      );
      setExternalMemberData(groupedExternalData);
    }
  }, [accountLevelPeople]);

  const handleclosesnacks = () => {
    setfirsttimesnackvisible(false);
  };

  const { currentUserData } = useAppSelectors();

  const handlesave = async () => {
    if (isSaving) {
      return;
    }
    const reqbody = {
      group_name: newGroupName,
      description: newGroupDescription,
      subscriber_id: userData?.profileData?.data?.activeSubscriber?.id,
      members: [
        ...selectedGroupMember?.selectedInternalGroupMember,
        ...selectedGroupMember?.selectedExternalGroupMember,
      ],
    };

    setIsSaving(true);
    try {
      await handlesavearkchatgroup(reqbody);
    } finally {
      setIsSaving(false);
    }
  };

  const handleChangePermission = async (event, selectedPerson) => {
    if (event.target.checked) {
      setMemberPermission([...memberPermission, selectedPerson?.userId]);
      const reqBody = {
        user_id: selectedPerson?.userId,
        permission_type: GroupLevelArkchatPermission.MANAGER,
        target_subscriber_id: selectedPerson?.targetSubscriberId,
        is_external: false,
      };
      if (selectedInternalMember?.includes(selectedPerson?.userId)) {
        const updatedSelectedGroupMember =
          selectedGroupMember.selectedInternalGroupMember?.map((item) =>
            item?.user_id === selectedPerson?.userId
              ? {
                  ...item,
                  permission_type: GroupLevelArkchatPermission.MANAGER,
                }
              : item
          );
        setSelectedGroupMember({
          ...selectedGroupMember,
          selectedInternalGroupMember: updatedSelectedGroupMember,
        });
      } else {
        setSelectedGroupMember({
          ...selectedGroupMember,
          selectedInternalGroupMember: [
            ...selectedGroupMember.selectedInternalGroupMember,
            reqBody,
          ],
        });
        setSelectedInternalMember([
          ...selectedInternalMember,
          selectedPerson?.userId,
        ]);
      }
    } else {
      const updatedmemberPermission = memberPermission?.filter(
        (id) => id !== selectedPerson?.userId
      );
      setMemberPermission(updatedmemberPermission);
      const updatedSelectedGroupMember =
        selectedGroupMember.selectedInternalGroupMember?.map((item) =>
          item?.user_id === selectedPerson?.userId
            ? { ...item, permission_type: GroupLevelArkchatPermission.USER }
            : item
        );
      setSelectedGroupMember({
        ...selectedGroupMember,
        selectedInternalGroupMember: updatedSelectedGroupMember,
      });
    }
  };
  const handleSelectInternalMember = async (event, selectedPerson) => {
    if (event.target.checked) {
      setSelectedInternalMember([
        ...selectedInternalMember,
        selectedPerson?.userId,
      ]);
      const reqBody = {
        user_id: selectedPerson?.userId,
        permission_type: GroupLevelArkchatPermission.USER,
        target_subscriber_id: selectedPerson?.targetSubscriberId,
        is_external: false,
      };
      setSelectedGroupMember({
        ...selectedGroupMember,
        selectedInternalGroupMember: [
          ...selectedGroupMember.selectedInternalGroupMember,
          reqBody,
        ],
      });
    } else {
      const updatedSelectedMember = selectedInternalMember?.filter(
        (id) => id !== selectedPerson?.userId
      );
      const updatedmemberPermission = memberPermission?.filter(
        (id) => id !== selectedPerson?.userId
      );
      const updatedSelectedGroupMember =
        selectedGroupMember.selectedInternalGroupMember?.filter(
          (item) => item?.user_id !== selectedPerson?.userId
        );
      setSelectedGroupMember({
        ...selectedGroupMember,
        selectedInternalGroupMember: updatedSelectedGroupMember,
      });
      setSelectedInternalMember(updatedSelectedMember);
      setMemberPermission(updatedmemberPermission);
    }
  };
  const handleSelectExternalPerson = async (
    event,
    selectedPerson,
    companyName
  ) => {
    if (event.target.checked) {
      const reqBody = {
        user_id: selectedPerson?.userId,
        permission_type: GroupLevelArkchatPermission.USER,
        target_subscriber_id: selectedPerson?.targetSubscriberId,
        is_external: true,
      };
      setSelectedGroupMember({
        ...selectedGroupMember,
        selectedExternalGroupMember: [
          ...selectedGroupMember.selectedExternalGroupMember,
          reqBody,
        ],
      });
      if (externalGroupMember[companyName]?.length > 0) {
        const companyUserId = {
          [companyName]: [
            ...externalGroupMember[companyName],
            selectedPerson?.userId,
          ],
        };
        setExternalGroupMemebr({ ...externalGroupMember, ...companyUserId });
      } else {
        const companyUserId = { [companyName]: [selectedPerson?.userId] };
        setExternalGroupMemebr({ ...externalGroupMember, ...companyUserId });
      }
    } else {
      const updatedCompanyUserId = externalGroupMember[companyName]?.filter(
        (item) => item !== selectedPerson?.userId
      );
      const updatedData = { [companyName]: updatedCompanyUserId };
      const updatedSelectedGroupMember =
        selectedGroupMember.selectedExternalGroupMember?.filter(
          (item) => item?.user_id !== selectedPerson?.userId
        );
      setSelectedGroupMember({
        ...selectedGroupMember,
        selectedExternalGroupMember: updatedSelectedGroupMember,
      });
      setExternalGroupMemebr({ ...externalGroupMember, ...updatedData });
    }
  };

  const handleSelecteAllExternalCompanyMember = (
    event,
    selectedCompanyPerson,
    companyName
  ) => {
    if (event.target.checked) {
      const userIdData = selectedCompanyPerson[companyName]?.map(
        (user) => user?.userId
      );
      const updatedGroupMemberData = selectedCompanyPerson[companyName]?.map(
        (user) => {
          return {
            user_id: user?.userId,
            permission_type: GroupLevelArkchatPermission.USER,
            target_subscriber_id: user?.targetSubscriberId,
            is_external: true,
          };
        }
      );
      const companyUserId = { [companyName]: userIdData };
      setExternalGroupMemebr({ ...externalGroupMember, ...companyUserId });
      setSelectedGroupMember({
        ...selectedGroupMember,
        selectedExternalGroupMember: [
          ...selectedGroupMember?.selectedExternalGroupMember,
          ...updatedGroupMemberData,
        ],
      });
    } else {
      handleRemoveSelectedCompanyMembers(externalGroupMember[companyName]);
      const updatedExternalGroupMember = { ...externalGroupMember };
      delete updatedExternalGroupMember[companyName];
      setExternalGroupMemebr(updatedExternalGroupMember);
    }
  };
  const handleRemoveSelectedCompanyMembers = (idsToRemove) => {
    const updatedSelectedExternalGroupMember =
      selectedGroupMember.selectedExternalGroupMember?.filter(
        (member) => !idsToRemove.includes(member?.user_id)
      );
    setSelectedGroupMember({
      ...selectedGroupMember,
      selectedExternalGroupMember: updatedSelectedExternalGroupMember,
    });
  };

  const handleClickExternal = () => {
    setActiveButton("external");
  };

  const handleClickInternal = () => {
    setActiveButton("internal");
  };

  // Looked up once per render instead of a scan per member; the rows'
  // handler keeps its identity (see InternalMemberRow).
  const selectedInternalIds = useMemo(() => new Set(selectedInternalMember || []), [selectedInternalMember]);
  const stable = useStableCallbacks({ handleSelectInternalMember });
  // A big account's people are built a part at a time as the list scrolls
  // (the tab shown: internal people, or external ones by company): building
  // every row at once took most of a second.
  const externalRowCount = externalMemberData.reduce((n, company) => n + (Object.values(company)[0]?.length || 0), 0);
  const tabRows = activeButton === "internal" ? accountLevelPeople?.internalMember?.length || 0 : externalRowCount;
  const [shownRows, listRef, moreRef] = useProgressiveList(tabRows);
  const visibleExternal = [];
  let externalBudget = shownRows;
  for (const company of externalMemberData) {
    if (externalBudget <= 0) break;
    const rows = (Object.values(company)[0] || []).slice(0, externalBudget);
    externalBudget -= rows.length;
    visibleExternal.push({ company, rows });
  }

  return (
    <React.Fragment>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isSwitchAccountDrawerOpen}
        anchor={"right"}
      >
        <SwitchAccount
          setSwitchAccountDrawerOpen={setSwitchAccountDrawerOpen}
          setCreateNewOrgAccountDrawerOpen={setCreateNewOrgAccountDrawerOpen}
        />
      </Drawer>
      <Drawer
        sx={{ zIndex: 1202 }}
        open={isCreateNewOrgAccountDrawerOpen}
        anchor={"right"}
      >
        <NewOrganisationProfile
          setCreateNewOrgAccountDrawerOpen={setCreateNewOrgAccountDrawerOpen}
          setSwitchAccountDrawerOpen={setSwitchAccountDrawerOpen}
        />
      </Drawer>
      <Box sx={classes.drawerBody}>
        <Stack sx={{ flex: 1, minHeight: 0 }}>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={classes.header}
          >
            <Typography sx={classes.iconDiv}>
              <CloseIcon sx={classes.iconn} onClick={handleClosegroupdrawer} />
            </Typography>
            <Typography>{appContent?.KEY113}</Typography>
          </Stack>

          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            margin={"0.5rem 1.2rem 0rem 0.5rem"}
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              setSwitchAccountDrawerOpen(true);
            }}
          >
            <Typography
              sx={{
                fontSize: fontSizeSchemes.font16,
                fontWeight: 400,
                color: "#183243",
                margin: "0rem 0rem 0rem 0rem",
              }}
              title={`Creating group in: ${currentUserData?.activeSubscriber?.subscriberFirmName}`}
            >
              Creating group in:{" "}
              {currentUserData?.activeSubscriber?.subscriberFirmName}
            </Typography>
            <StyledSideBarInviteButton
              sx={{
                fontWeight: 400,
                fontSize: fontSizeSchemes.font14,
                color: colorSchemes.switchTxtLink,
                textDecoration: "underline",
                cursor: "pointer",
                "&:hover": {
                  color: "#1a5fb4",
                  textDecoration: "underline",
                },
              }}
            >
              Switch
            </StyledSideBarInviteButton>
          </Box>

          <Stack
            direction="column"
            // alignItems="end"
            spacing={2}
            justifyContent="start"
            sx={{ padding: "0.63rem 1.25rem 1.25rem" }}
          >
            <TextField
              type="text"
              label={appContent?.KEY114}
              value={newGroupName}
              variant="standard"
              name="addTopic"
              sx={{ width: "20.62rem" }}
              required
              error={newGroupName ? false : isRequired}
              onChange={handleNameChange}
            />
            <TextField
              type="text"
              label="Description"
              multiline
              value={newGroupDescription}
              variant="standard"
              name="addDescription"
              sx={{ width: "20.62rem" }}
              inputProps={{ maxLength: 180 }}
              onChange={handleDescriptionChange}
              helperText="Optional, Max 160 characters"
            />
          </Stack>
          <Stack
            position="static"
            direction="row"
            alignItems="center"
            spacing={2}
            sx={classes.header}
          >
            <Typography fontSize={14} paddingLeft={1}>
              {appContent?.KEY201}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            justifyContent="left"
            alignItems="center"
            spacing={1}
            padding="0.75rem 1.18rem 0.75rem 1.2rem"
          >
            <Button
              sx={
                activeButton === "internal"
                  ? classes.activeButton
                  : classes.internalExternalButton
              }
              variant="contained"
              onClick={handleClickInternal}
            >
              {appContent?.KEY202}
            </Button>
            <Button
              sx={
                activeButton === "external"
                  ? classes.activeButton
                  : classes.internalExternalButton
              }
              variant="contained"
              onClick={handleClickExternal}
            >
              {appContent?.KEY203}
            </Button>
          </Stack>
          {firsttimesnackvisible && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={classes.groupMember}
            >
              {/* <Typography sx={classes.iconDiv}>
                <CloseIcon sx={classes.iconn} onClick={handleclosesnacks} />
              </Typography> */}
              <Typography width={"19.37rem"} fontSize={"0.75rem"}>
                {appContent?.KEY206}
              </Typography>
            </Stack>
          )}
          {/* list */}

          <Box
            ref={listRef}
            sx={{
              overflow: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": {
                width: "1px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#F9F8F8",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "grey",
              },
            }}
          >
            {activeButton === "internal" && (
              <Box>
                {accountLevelPeople?.internalMember?.slice(0, shownRows).map((item) => (
                  <InternalMemberRow
                    key={item?.userId + "internalCreategrp"}
                    item={item}
                    selected={selectedInternalIds.has(item?.userId)}
                    viewerIsAccountOwner={userData?.profileData?.data?.accountOwner}
                    onSelect={stable.handleSelectInternalMember}
                  />
                ))}
              </Box>
            )}
            {activeButton == "external" && (
              <Box>
                {visibleExternal.map(({ company, rows }, index) => (
                  <Box padding="0px 19px 6px 12px">
                    <FormControlLabel
                      sx={{
                        ".MuiFormControlLabel-label": {
                          fontWeight: 500,
                          color: "#000000",
                        },
                      }}
                      control={
                        <Checkbox
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 30,
                              color: "#183243",
                            },
                          }}
                          checked={
                            Object.values(company)[0]?.length ===
                            externalGroupMember[Object.keys(company)[0]]?.length
                          }
                          onChange={(event) =>
                            handleSelecteAllExternalCompanyMember(
                              event,
                              company,
                              Object.keys(company)[0]
                            )
                          }
                          icon={
                            <NameBadge
                              sx={{ color: "#183243" }}
                              size="small"
                              variant="contained"
                            >
                              <Typography
                                color={"#183243"}
                                fontSize={"0.75rem"}
                                fontWeight={600}
                              >
                                {Object.keys(company)[0] &&
                                  Object.keys(company)[0][0]}
                              </Typography>
                            </NameBadge>
                          }
                        />
                      }
                      label={
                        <Typography fontWeight={600} fontSize={"0.88rem"}>
                          {Object.keys(company)[0]}
                        </Typography>
                      }
                    />
                    {rows.map((item, i) => (
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={1}
                        key={item?.userId + "externalInvitegrpmember"}
                      >
                        <Box width={"62%"} padding={"0rem 0rem 0rem 1.2rem"}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 25,
                                    color: "#183243",
                                  },
                                }}
                                checked={
                                  externalGroupMember[Object.keys(company)[0]]
                                    ?.length > 0 &&
                                  externalGroupMember[
                                    Object.keys(company)[0]
                                  ]?.includes(item?.userId)
                                }
                                onChange={(event) =>
                                  handleSelectExternalPerson(
                                    event,
                                    item,
                                    Object.keys(company)[0]
                                  )
                                }
                                icon={
                                  <NameBadge
                                    sx={{
                                      color: "#183243",
                                      width: "1.55rem",
                                      height: "1.55rem",
                                    }}
                                    size="small"
                                    variant="contained"
                                  >
                                    <Typography
                                      color={"#183243"}
                                      fontSize={"0.75rem"}
                                    >
                                      {item?.userInfo?.firstName &&
                                        item?.userInfo?.firstName[0]}
                                    </Typography>
                                  </NameBadge>
                                }
                              />
                            }
                            label={`${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`}
                          />
                        </Box>
                        {/* <FormControlLabel
                        control={
                          <Switchs
                            switchLabel="Owner"
                            name={item?.userId}
                            checked={groupMemeberPermission?.[item?.userId]}
                            handleChange={(event) =>
                              handleChangeInternalMemberGrpPermission(
                                event,
                                item
                              )
                            }
                          />
                        }
                      /> */}
                      </Stack>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
            {shownRows < tabRows && <Box ref={moreRef} height="1px" />}
          </Box>
        </Stack>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          padding="0.75rem 1.18rem 0.75rem 0.75rem"
        >
          <Button
            sx={{
              background: "#DB0011",
              color: "white",
              borderRadius: "3px",
              "&:hover": {
                background: "#DB0011",
              },
              "&.Mui-disabled": {
                background: "#DB0011",
                color: "white",
                opacity: 0.6,
              },
            }}
            variant="contained"
            disabled={isSaving}
            onClick={handlesave}
          >
            {appContent?.KEY204}
          </Button>
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default CreateGroup;
